import { define, html, store } from "hybrids";

import ArtistVideo from "~/stores/ArtistVideo";

interface VVideoCard {
  video?: ArtistVideo;
}

const handleClick = ({ video }: { video: ArtistVideo }) => {
  window.location.href = video.url
}

export default define<VVideoCard>({
  tag: "v-video-card",
  video: store(ArtistVideo),
  render: ({ video }) => html`
    <div onclick="${handleClick}" class="video-link-holder">
      <v-ui-flexbox flow="row" gap="small">
        <v-ui-poster src="${video?.thumbnail}"></v-ui-poster>
        <v-ui-text>${video?.name}</v-ui-text>
      </v-ui-flexbox>
    </div>
  `.css`
    .video-link-holder {
      cursor: pointer;
    }
      
    v-ui-poster {
      flex: 1;
      max-width: 140px;
    }

    v-ui-text {
      flex: 2;
    }
  `,
});
